import React from 'react';
import { Navbar } from '../components/Navbar';
import { ProductReviewsPage } from '../components/ProductReviewsPage';
import { Footer } from '../components/Footer';
export const ProductReviews = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2357" data-mp="3v0co0umo4ymm">
      <Navbar data-id="element-2358" data-mp="3uz1hwo5r3esc" />
      <ProductReviewsPage data-id="element-2359" data-mp="3r028aq92qtuk" />
      <Footer data-id="element-2360" data-mp="3r0u5g5ibkzmy" />
    </div>;
};